module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("../assets/images/gzheader.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', [_c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/1.png'),
      expression: "'/static/images/home/1.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/2.png'),
      expression: "'/static/images/home/2.png'"
    }]
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/3.png'),
      expression: "'/static/images/home/3.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/4.png'),
      expression: "'/static/images/home/4.png'"
    }]
  })]), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_list"
  }, [_c('div', {
    staticClass: "product_item"
  }, [_c('img', {
    staticStyle: {
      "width": "176px",
      "display": "inline-block"
    },
    attrs: {
      "src": require("../assets/images/gzqrcodes.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("扫码下载")]), _vm._v(" "), _c('p', [_vm._v("维词学生版APP")])])]), _vm._v(" "), _c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/aistudent/weici-student.exe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/pc.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("维词数智化学生端")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词app是一款专为高中生")]), _vm._v(" "), _c('p', [_vm._v("打造的英语学习软件")]), _vm._v(" "), _c('p', [_vm._v("让用户可以轻松的掌握高中英语知识")]), _vm._v(" "), _c('p', [_vm._v("Victor English Vocabulary APP is specially designed for high school students, ")]), _vm._v(" "), _c('p', [_vm._v("\n            to satisfy the needs for English studies and to master high school English knowledge and skills\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/arrow.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("学习资源丰富")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("内容精准")]), _vm._v(" "), _c('p', [_vm._v("5676个精讲词条，15979个例句音频")]), _vm._v(" "), _c('p', [_vm._v("大数据精选知识点，分层深度学习")]), _vm._v(" "), _c('p', [_vm._v("精彩发现区，让单词学习有趣、有效")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("同步课堂教学")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("融入学习各个场景")]), _vm._v(" "), _c('p', [_vm._v("同步教学进度、教材预习，课堂更轻松")]), _vm._v(" "), _c('p', [_vm._v("精选练习、作业、老师推荐，学习有的放矢")]), _vm._v(" "), _c('p', [_vm._v("词汇分级、话题学习，备考轻松")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("练测题型多样")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("考察全面")]), _vm._v(" "), _c('p', [_vm._v("七大题型，覆盖单词学习核心要点")]), _vm._v(" "), _c('p', [_vm._v("错题自动收录，随时随地巩固")]), _vm._v(" "), _c('p', [_vm._v("告别枯燥刷题，学习过程更有趣")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("智能语音互动")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("听说能力提升快")]), _vm._v(" "), _c('p', [_vm._v("真人离线发音，提供精准语音输入")]), _vm._v(" "), _c('p', [_vm._v("单词例句跟读，告别“哑巴”英语")]), _vm._v(" "), _c('p', [_vm._v("错误发音即时纠正，英语学习更自信")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-228d8f57","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = 82
// module chunks = 0